export default __webpack_public_path__ + "static/media/theme2.094d9d57.jpg";